import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SecondsToHoursPipe } from './seconds-to-hours.pipe';

@NgModule({
  imports: [CommonModule],
  declarations: [SecondsToHoursPipe],
  exports: [SecondsToHoursPipe],
})
export class SecondsToHoursShared {}
